export const TOGGLE_INSTRUCTION = 'TOGGLE_INSTRUCTION';

function S4() {
  return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
}

function toggle() {
  return {
    type: TOGGLE_INSTRUCTION,
    instructionToggled: `${ S4() }${ S4() }-${ S4() }-4${ S4().substr(0, 3) }-${ S4() }-${ S4() }${ S4() }${ S4() }`.toLowerCase()
  };
}

export function toggleInstruction() {
  return (dispatch) => {
    dispatch(toggle());
  };
}
